import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  IOurEntity,
  getOurEntityById,
  ClientDTO,
  getAllClientList,
  getOurEntityClient,
  ClientOurEntityDTO,
} from 'wisestep-api';
import { FormWizard, WsTitleBanner } from 'wisestep-base';

import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';
import { getClientsBreadCrumbList } from '../clientDetails/helper/clientDetailsHelper';

import OurEntityCreateForm from './component/OurEntityCreateForm';
import OurEntityClient from './ourentity/OurEntityClient';

type OurEntityPageParams = {
  ourEntityId: string;
};
const OurEntityForm = () => {
  const [formWizardCurrentStep, setFormWizardCurrentStep] = useState(0);
  const [formWizardCurrentChildStep, setFormWizardCurrentChildStep] = useState(0);
  const [ourEntityId, setOurEntityId] = useState('');
  const [clientListData, setClientListData] = useState<ClientDTO[]>([]);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [preSelectedRows, setPreSelectedRows] = useState<number[]>([]);

  const formWizardMenuItemClick = (id: number) => {
    setFormWizardCurrentStep(id);
  };
  const onFormWizardArrowClick = () => {
    navigate(`/organisationEntity/list`);
  };

  const menuItems = [
    {
      id: 0,
      label: 'Organisation Entites',
      onClick: () => formWizardMenuItemClick(0),
      subList: [
        {
          id: 0,
          label: 'Organisation Details',
          onClick: () => setFormWizardCurrentChildStep(0),
        },
      ],
    },
  ];

  const navigate = useNavigate();

  const [ourEntityData, setOurEntityData] = useState<IOurEntity>();

  const params = useParams<OurEntityPageParams>();

  const ourEntityIdParam: string = params.ourEntityId ?? '';

  useEffect(() => {
    if (ourEntityIdParam && ourEntityIdParam != '') {
      const getOurEntityData = async () => {
        const response = await getOurEntityById(ourEntityIdParam);
        setOurEntityData(response.data.data);
      };
      getOurEntityData();
    }
    const getClientList = async () => {
      const response = await getAllClientList();
      setClientListData(response.data.data);
    };
    getClientList();
  }, [ourEntityIdParam]);

  useEffect(() => {
    const getOurEntityClientList = async () => {
      if (clientListData.length == 0) {
        return;
      }
      if (ourEntityIdParam) {
        setOurEntityId(ourEntityIdParam);
        const response = await getOurEntityClient(ourEntityIdParam);
        const selectedIndices: number[] = [];
        const clientOurEntityDTOs: ClientOurEntityDTO[] = response.data?.data ?? [];
        const clientIds = clientOurEntityDTOs.map((o) => o.clientId);
        clientListData.length > 0 &&
          clientListData.forEach((clientObj, index) => {
            if (clientObj.id) clientIds.includes(clientObj?.id) && selectedIndices.push(index);
          });
        setSelectedRows(selectedIndices);
        setPreSelectedRows(selectedIndices);
      }
    };
    getOurEntityClientList();
  }, [ourEntityIdParam, clientListData]);

  return (
    <>
      <WsBreadCrumbs
        breadCrumbsList={getClientsBreadCrumbList(
          'ORGANIZATION_ENTITY',
          'Add Organization Entity Details'
        )}
      />
      <FormWizard
        menuItems={menuItems}
        onArrowButtonClick={onFormWizardArrowClick}
        currentStep={formWizardCurrentStep}
        currentChildStep={formWizardCurrentChildStep}
        title="Organisation Entities"
      >
        <WsTitleBanner title="Organisation Details" backButton={false} />

        {formWizardCurrentStep == 0 && formWizardCurrentChildStep == 0 && (
          <OurEntityCreateForm ourEntityDataObj={ourEntityData} setOurEntityId={setOurEntityId} />
        )}
        {formWizardCurrentStep == 0 && formWizardCurrentChildStep == 1 && (
          <OurEntityClient
            ourEntityId={ourEntityId}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            ourClientListData={clientListData ?? []}
            getPreSelectedRow={preSelectedRows}
          />
        )}
      </FormWizard>
    </>
  );
};

export default OurEntityForm;
